import { render, staticRenderFns } from "./Acceptance.vue?vue&type=template&id=84263b5e&scoped=true&"
import script from "./Acceptance.vue?vue&type=script&lang=js&"
export * from "./Acceptance.vue?vue&type=script&lang=js&"
import style0 from "./Acceptance.vue?vue&type=style&index=0&id=84263b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84263b5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardTitle,VSelect})
